import { createFingerPrint, canUseProxy } from "./utils";
import { getIpInfo } from "./ip";


let info = {};
let isCreating = false;
let waitResolveArr = [];

// 解决首次同时请求导致多次请求接口的问题
if (canUseProxy()) {
    info = new Proxy(info, {
        set(target, property, value) {
            target[property] = value;
            if (property == "fingerTxt" && value && waitResolveArr.length) {
                for (let key in waitResolveArr) {
                    try {
                        waitResolveArr[key]();
                    } catch (_error) { }
                }
            }
            return true;
        },
    });
}

const waitPromise = () => {
    return new Promise(resolve => {
        waitResolveArr.push(resolve);
    });
};

export const getFingerPrint = async (data = {}) => {
    try {
        if (!info.fingerTxt) {
            let _localstorageFinger = window.localStorage.getItem('finger_id_2');
            if (_localstorageFinger) {
                info.fingerTxt = _localstorageFinger;
            }
        }
    } catch (error) { }
    if (!info.fingerTxt && !isCreating) {
        if (canUseProxy()) {
            isCreating = true;
        }
        if (!Object.keys(data).length) {
            let ipInfo = await getIpInfo();
            if (ipInfo) {
                data = ipInfo;
            }
        }
        info.fingerTxt = await createFingerPrint(data);
        try {
            window.localStorage.setItem('finger_id_2', info.fingerTxt);
        } catch (error) { }
        isCreating = false;
    }
    if (!info.fingerTxt && isCreating) {
        await waitPromise();
    }
    return info.fingerTxt;
};

